/**
 * Cookie consent banner functionality
 */

// Initialize cookie banner on page load
function initCookieBanner() {
  // Check if user already accepted
  if (!localStorage.getItem('cookiesAccepted')) {
    const cookieNotice = document.getElementById('cookie-notice');
    if (cookieNotice) {
      cookieNotice.style.display = 'flex';
    }
  }
}

// Accept cookies function - needs to be global for onclick handler
window.acceptCookies = function() {
  localStorage.setItem('cookiesAccepted', 'true');
  const cookieNotice = document.getElementById('cookie-notice');
  if (cookieNotice) {
    cookieNotice.style.display = 'none';
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieBanner);
} else {
  initCookieBanner();
}

export { initCookieBanner };
